import { create } from 'zustand';

export interface AuthUser {
  name: string;
  email: string;
  /** Keycloak client roles (`resource_access.bop_<env>.roles`); empty under Okta. */
  roles?: string[];
}

interface AuthState {
  token: string | null;
  /** epoch ms — null until the first setOidcSession call */
  tokenExpiresAt: number | null;
  user: AuthUser | null;
  /** oidc mode: applies a freshly minted token from GET /api/auth/token (see token-refresh.ts) */
  setOidcSession: (token: string, expiresAt: number, user: AuthUser) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: null,
  tokenExpiresAt: null,
  user: null,
  // In-memory cache of the HttpOnly cookie from functions/api/auth/callback/okta.ts —
  // refreshed by token-refresh.ts, never persisted.
  setOidcSession: (token, expiresAt, user) => {
    set({ token, tokenExpiresAt: expiresAt, user });
  },
}));

// Synchronous by design — token-refresh.ts keeps this fresh via background refresh,
// so client.ts/websocket.ts never need to await it.
export const getUserAccessToken = (): string | null => useAuthStore.getState().token;
